import React, { useState } from "react";

// module imports

// import "./ThreeWayMatching.css";
import ThreeWayMatching from "./ThreeWayMatching.jsx";
import TWMOverviewDashboard from "./TWMOverviewDashboard.jsx";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources.js";
import { useSelector } from "react-redux";
import { Box, Button, Card, Grid, Stack, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle.jsx";



export const TWMHome = () => {

    const loginData = useSelector((state) => state.loginData.value);
    const [auth_token] = useState(loginData?.auth_token);
    const [user_token] = useState(loginData?.user?.user_token);
    const [user_role] = useState(loginData?.user?.role);

    const [nextTwmCode, setNextTwmCode] = useState("");

    const [mode, setMode] = useState("main");


    const fetchNextCode = async () => {
        try {
            const { data } = await axios.post(
                API_ENDPOINT.peek_next_twm_code,
                { user_token },
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );
            setNextTwmCode(data?.next_match_code || "");
        } catch {
            setNextTwmCode("");
        }
    };


    return (
        <div>

            <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} p={2}>
                {<HeaderTitle titleText={"P2P Compliance & Matching"} />}

                {/* {mode == 'main' && user_role == "Buyer" && (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CloudUploadIcon />}
                        onClick={async () => {
                            await fetchNextCode();
                            setMode("upload");
                        }}
                        sx={{
                            ml: { xs: 0, sm: 2 },
                            width: { xs: "100%", sm: "auto" },
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            fontSize: "14px",
                        }}
                    >
                        Run 3-Way Match
                    </Button>
                )} */}
            </Stack>


           



            {/* <TWMOverviewDashboard /> */}
            <ThreeWayMatching nextTwmCode={nextTwmCode} uploadmode={mode} onModeChange={setMode} />
        </div>
    )
}